export default __webpack_public_path__ + "static/media/pt.0ceb3fde.svg";